<template lang="html">
  <SceneContent v-bind="$props"/>
</template>

<script>
import SceneContent from '@/components/vacancy/preferences/SceneContent.vue'

export default {
  name: 'process-vacancy-preferences-scene',

  components: {
    SceneContent
  },

  props: {
    vacancy: Object
  },

  methods: {
    fetch () {
      this.$store.dispatch('process/deloitteSF/vacancy/SFVacanciesList/fetch')
    }
  },

  beforeMount() {
    this.fetch()
  }
}
</script>
